<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel
      v-for="(faqTheme, indexTheme) in faqThemes"
      :key="indexTheme"
      @click="selectTheme(faqTheme)"
    >
      <v-expansion-panel-header class="pl-4 hauteur-panel">
        <div class="text-md-left ml-2 mt-3">
          <v-row no-gutters>
            <v-card-text
              class="text-h6 font-weight-bold"
              :class="isThemeSelected(faqTheme.id) ? 'theme-selected-color' : 'theme'"
            >
              {{ faqTheme.libelle }}
            </v-card-text>
            <v-badge
              v-if="isThemeHasAtLeastOneNouveaute(faqTheme)"
              class="pb-2"
              color="red"
              left
              text-color="white"
              content="nouveautés!"
            />
          </v-row>
        </div>
      </v-expansion-panel-header>
      <v-divider />
      <v-expansion-panel-content class="pa-0">
        <v-list class="pa-0">
          <v-list-item
            v-for="(faqQuestionReponse, indexQuestion) in faqTheme.questionsReponses"
            :key="indexQuestion"
            class="pa-0 mt-3"
          >
            <v-list-item-content class="pa-0">
              <v-divider
                v-show="indexQuestion > 0"
                :key="indexQuestion"
                class="mb-3"
              />
              <div class="align-end">
                <v-chip
                  v-if="isNouveaute(faqQuestionReponse)"
                  class="pb-2"
                  color="red"
                  text-color="white"
                  x-small
                >
                  <span class="mt-2 pr-0 pr-md-1">
                    nouveauté!
                  </span>
                </v-chip>
              </div>
              <v-card-text class="text-subtitle-1 font-weight-bold pa-0">
                {{ faqQuestionReponse.intitule }}
              </v-card-text>
              <div class="my-2 text-justify">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="faqQuestionReponse.reponseSmartphone" />
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import faqService from '@/service/faq.service'
import {clone} from '@/utils/clone'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FaqVueMobile',
  props: {
    faqThemes: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      panel: [],
      themeSelected: {},
      isAffichageQuestionsReponses: null
    }
  },

  computed: {
    ...mapGetters({
      getHasAtLeastOneNouveaute: 'faq/getHasAtLeastOneNouveaute'
    })
  },

  methods: {
    ...mapActions({ readQuestion: 'faq/readQuestion' }),
    hasAtLeastOneNouveaute (theme) {
      this.getHasAtLeastOneNouveaute(theme)
    },
    isNouveaute (question) {
      return faqService.isQuestionReponseNouveauteVueMobileActive(question)
    },
    selectTheme (theme) {
      if (this.isAffichageQuestionsReponses && (this.themeSelected == null || theme.id === this.themeSelected.id)) {
        this.isAffichageQuestionsReponses = false
        this.themeSelected = null
      } else {
        this.isAffichageQuestionsReponses = true
        this.themeSelected = clone(theme)

        for (const question of theme.questionsReponses) {
          this.readQuestion(question)
        }
      }
    },
    isThemeSelected (idTheme) {
      return this.themeSelected ? this.themeSelected.id === idTheme : false
    },
    isThemeHasAtLeastOneNouveaute (theme) {
      let isChipNouveauteAffiche = false
      if (this.themeHasAtLeastOneNouveaute && this.themeHasAtLeastOneNouveaute.idTheme === theme.id) {
        isChipNouveauteAffiche = this.themeHasAtLeastOneNouveaute.isThemeHaveAtLeastOneNouveaute
      } else {
        isChipNouveauteAffiche = faqService.hasAtLeastOneNouveaute(theme)
      }
      return isChipNouveauteAffiche
    }
  }

}
</script>

<style lang="scss" scoped>
.font-reponse {
  font-size: 17px;
  color: black;
}
.hauteur-panel {
  height: auto;
}
.align-end {
  text-align: end;
}
.theme-selected-color {
  color: #967a27;
}
.theme {
  color: black;
}
</style>
